import { render, staticRenderFns } from "./DeviceNotificationDetail.vue?vue&type=template&id=4ff2eb50"
import script from "./DeviceNotificationDetail.vue?vue&type=script&lang=js"
export * from "./DeviceNotificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports